import { create } from 'zustand';

import type { PublicationCategory } from '../../../shared/types/common';

export type CategoryFilter = PublicationCategory | 'all' | 'unknown';

type Results = unknown[];
type ResultsUpdater = Results | ((prev: Results) => Results);

type AverageViewsCacheState = {
  results: Results;
  category: CategoryFilter;
  /** За какой период посчитано — подпись над таблицей, когда период уже сменили. */
  computedFor: string | null;
  /** Расчёт идёт: флаг в сторе, чтобы после возврата на вкладку нельзя было запустить второй. */
  isLoading: boolean;
  progress: string;
  setResults: (updater: ResultsUpdater) => void;
  setCategory: (category: CategoryFilter) => void;
  setComputedFor: (label: string | null) => void;
  setLoading: (isLoading: boolean) => void;
  setProgress: (progress: string) => void;
};

/**
 * «Средние просмотры» считаются по всем аккаунтам подряд и занимают минуты.
 * Поэтому посчитанное, ход расчёта и выбранная категория живут в сторе: уход
 * на соседнюю вкладку не должен стирать то, чего ждали. Период — общий для
 * раздела (адрес и память), см. useDateRangeParams.
 */
export const useAverageViewsCache = create<AverageViewsCacheState>((set) => ({
  results: [],
  category: 'all',
  computedFor: null,
  isLoading: false,
  progress: '',
  setResults: (updater) =>
    set((state) => ({
      results: typeof updater === 'function' ? updater(state.results) : updater,
    })),
  setCategory: (category) => set({ category }),
  setComputedFor: (computedFor) => set({ computedFor }),
  setLoading: (isLoading) => set({ isLoading }),
  setProgress: (progress) => set({ progress }),
}));
